import Swiper, {Navigation} from 'swiper';
Swiper.use([Navigation]);

document.addEventListener('DOMContentLoaded', function() {
    const whatClientsSaySwiper = new Swiper('.js-what-clients-say-slider', {
        loop: true,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 60,
        navigation: {
            nextEl: '.js-what-clients-say-btn-next',
            prevEl: '.js-what-clients-say-btn-prev',
        },
        breakpoints: {
            768: { slidesPerView: 2 },
            1440: { spaceBetween: 110 }
        }
    });

    const awardsSwiper = new Swiper('.js-awards-slider', {
        loop: true,
        grabCursor: true,
        slidesPerView: 2,
        spaceBetween: 20,
        navigation: {
            nextEl: '.js-awards-btn-next',
            prevEl: '.js-awards-btn-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            1024: { slidesPerView: 4 },
            1366: { slidesPerView: 6 }
        }
    });

    let achievements;

    function initOnMobileSwiper() {
        if (!achievements && window.innerWidth < 769) { // Check if swiper doesn't exist and screen is mobile
            achievements = new Swiper('.js-achievements-slider', {
                slidesPerView: 'auto',
                centeredSlides: false,
                spaceBetween: 10,

                navigation: {
                    nextEl: '.js-achievements-btn-next',
                    prevEl: '.js-achievements-btn-prev',
                },
            });
        }
    }

    function destroySwiper() {
        if (achievements && window.innerWidth >= 769) { 
            achievements.destroy(true, true); // Destroy the Swiper instance
            achievements = null; // Reset
        }
    }

    initOnMobileSwiper();

    let resizeTimeout;

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            initOnMobileSwiper();

            if (typeof achievements === 'object' && achievements !== null && achievements.initialized && window.innerWidth >= 769) {
                destroySwiper();
            }
            
        }, 200);
    });
});